module.exports = __webpack_public_path__ + "static/media/sauna.ec723183.png";